<template>
    <v-data-table
        :headers="headers"
        :items="paginationItems.data"
        :items-per-page="paginationParams.per_page"
        :page="paginationParams.page"
        :server-items-length="paginationItems.total"
        :loading="loading"
        sort-by="id"
        class="border"
        @update:page="changePage"
        @update:items-per-page="changeItemsPerPage"
        :footer-props="footerProps"
        @update:sort-by="sortBy"
        @update:sort-desc="sortDesc"

    >
        <template v-slot:top>
            <v-toolbar flat color="white">
                <v-dialog fullscreen v-model="dialog" max-width="800px">
                    <template v-slot:activator="{ on }">
                        <v-btn color="primary" dark class="mb-2" v-on="on">{{ trans('buttons.plan.newItem') }}</v-btn>
                    </template>
                    <plan-form
                        v-if="dialogLoaded"
                        :itemId="editedItem"
                        v-on:saved="onSave"
                        v-on:updated="onUpdate"
                        v-on:close="close"
                    />
                </v-dialog>
            </v-toolbar>
        </template>
        <template v-slot:item.actions="{ item }">
            <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
            <v-icon small @click="deleteItem(item)">mdi-delete</v-icon>
        </template>
        <template v-slot:item.created_at="{ item }">
            {{ item.created_at | mysqlDate }}
        </template>
        <template v-slot:item.default="{ item }">
            <v-icon
                v-if="item.is_default"
                color="green"
                dark
                >mdi-check</v-icon>
        </template>
        <template v-slot:item.scope="{ item }">
            {{ options.planScopesKeyed ? options.planScopesKeyed[item.scope] : '' }}
        </template>
        <template v-slot:item.currency="{ item }">
            <template v-if="item.prices && item.prices.length">
                <div v-for="(price, index) in item.prices" :key="index">
                    {{ options.planCurrenciesKeyed ? options.planCurrenciesKeyed[price.currency] : '' }}
                </div>
            </template>
        </template>
        <template v-slot:item.monthly="{ item }">
            <template v-if="item.prices && item.prices.length">
                <div v-for="(price, index) in item.prices" :key="index">
                    {{ price.monthly || '-' }}
                </div>
            </template>
        </template>
        <template v-slot:item.halfYearly="{ item }">
            <template v-if="item.prices && item.prices.length">
                <div v-for="(price, index) in item.prices" :key="index">
                    {{ price.halfYearly || '-' }}
                </div>
            </template>
        </template>
        <template v-slot:item.yearly="{ item }">
            <template v-if="item.prices && item.prices.length">
                <div v-for="(price, index) in item.prices" :key="index">
                    {{ price.yearly || '-' }}
                </div>
            </template>
        </template>
    </v-data-table>
</template>

<script>
    import tableWithPagination from "@/mixins/tableWithPagination";

    export default {
        name: "PlanTable",
        components: {
            PlanForm: () => import('@/components/admin/plan/PlanForm'),
        },
        mixins: [tableWithPagination],
        data() {
            return {
                dialog: false,
                dialogLoaded: false,
                plans: {},
                headers: [
                    { text: "id", sortable: false, value: "id" },
                    { text: this.trans("fields.common.label"), value: "label", sortable: false },
                    { text: this.trans("fields.plan.default"), value: "default", sortable: false },
                    { text: this.trans("fields.common.scope"), value: "scope", sortable: false },
                    { text: this.trans("fields.common.currency"), value: "currency", sortable: false },
                    { text: this.trans("fields.plan.monthly"), value: "monthly", sortable: false },
                    { text: this.trans("fields.plan.halfYearly"), value: "halfYearly", sortable: false },
                    { text: this.trans("fields.plan.yearly"), value: "yearly", sortable: false },
                    { text: this.trans("fields.common.users"), value: "users_count", sortable: false },
                    { text: this.trans("fields.common.actions"), value: "actions", sortable: false },
                ],
                paginationParams: {
                    page: 1,
                    per_page: 10,
                },
                url: this.route('admin.plans.index'),
                deleteRoute: 'admin.plans.delete',

                editedItem: null,
            }
        },
        created() {
            this.editedItem = null;
            this.initialize();
            this.loadOptions({planScopes: true, planCurrencies: true});
        },
        watch: {
            dialog(val) {
                if (val){
                    this.dialogLoaded = true
                } else {
                    this.close();
                }
            }
        },
        methods: {
            onSave(){
                this.close();
                this.initialize();
            },
            onUpdate(){
                this.close();
                this.initialize();
            },
            editItem(item) {
                this.editedItem = item.id;
                this.dialog = true;
                this.dialogLoaded = true;
            },
            deleteItem(item) {
                if (confirm("Are you sure you want to delete this item?")){
                    axios.post(this.route(this.deleteRoute, item.id)).then( () => {
                        this.initialize();
                    }).catch( (err) => {
                        console.log(err)
                    })
                }
            },

            close() {
                this.dialog = false;
                setTimeout(() => {
                    this.editedItem = null;
                    this.dialogLoaded = false;
                }, 300);
            },


        },
        computed: {
            paginationItems: {
                get(){
                    return this.plans;
                },
                set(v){
                    this.plans = v;
                }
            },
        }
    }
</script>

<style scoped>
    .small-caption {
        font-size: 9px;
        margin-left: -6px;
    }
</style>
